// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  restaurantId: __t.u64().primaryKey().name("restaurant_id"),
  dayNumber: __t.i64().name("day_number"),
  claimedMask: __t.u32().name("claimed_mask"),
  streak: __t.u32(),
  lastCompletedDay: __t.i64().name("last_completed_day"),
});
